<template>
  <div>
    <template v-if="disabled">
      {{ data }}
    </template>
    <!-- class="demo-inline-spacing" class="form-control"
      :placeholder="$t('_components.placeholder.select')+label"-->
    <!-- :disabled-date="disabledDate" -->
    <a-month-picker
      v-model="data"
      placeholder="Select month"
      format="YYYY-MM"
      :allow-clear="option.allowClear"
    />
  </div>
</template>

<script>
const moment1 = moment()
export default {
  components: {
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: null,
    },
    option: {
      type: Object,
      default: () => ({
        allowClear: false,
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: moment(),
    }
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        if (e === null) {
          this.$emit('input', '')
        } else {
          const date = moment(e).format('YYYY-MM')
          this.$emit('input', date)
        }
      },
    },
    value: {
      handler(e) {
        // 用于清空选择器
        if (e === null) {
          this.data = moment(new Date()).format('YYYY-MM')
        }
        // if (!e) {
        //   this.data = moment(new Date()).format('YYYY-MM')
        // }
      },
      deep: true,
    },
  },
  mounted() {
  },
  methods: {
    moment: moment1,
    initMonthDate() {
      return moment(new Date())
    },
    dateChange(dates, dateStrings) {
      this.data = dateStrings
    },
    initDate() {
      const date = moment(this.value).format('YYYY-MM')
      this.$emit('input', date)
    },
  },
}

</script>

<style lang='scss'>
.form-control{
    height: 100%;
    width: 100%;
    margin:0
}
</style>
